export const gamesData = [
  {
    title: 'Letter Heist',
    description: 'Tap tiles to reveal letters and form 5 letter words before your opponent does.',
    technologies: ['React', 'Django',],
    category: 'Multiplayer',
    image: '/images/games/letter-heist.jpg',
    // github: 'https://github.com/yourusername/game1',
    demo: 'https://letterheist.app/heist/', // Add your game demo URL here
  },
  {
    title: 'Crossbeez', 
    description: 'Crossword like puzzle for Wordle enthusiasts',
    technologies: ['Flutter', 'Django', ],
    category: 'Word Game',
    image: '/images/games/crossbeez.jpg',
    // github: 'https://github.com/yourusername/game2',
    demo: 'https://crossbeez.app/', // Add your game demo URL here
  },
];

// To add a new game, add an object with this structure:
/*
{
  title: 'Your Game Title',
  description: 'A compelling description of what the game is about, gameplay mechanics, and what makes it special',
  technologies: ['Tech1', 'Tech2', 'Tech3'], // Game engines, languages, frameworks used
  category: 'Game Type', // e.g., 'Mobile Game', 'Web Game', 'Desktop Game', 'VR Game'
  image: '/images/games/your-image.jpg', // Optional - shown at top of card
  github: 'https://github.com/yourusername/game-repo', // Optional - GitHub repository
  demo: 'https://your-game-url.com', // Optional - Playable demo or store link
  article: 'https://your-blog-post-about-game.com', // Optional - Blog post about the game
}
*/
